import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Actuator } from '../../Libs/smart-home/models/smart-home.model'
import { LabeledOption } from '../../Types/globalTypes'

export const useActuatorOptions = (): LabeledOption<number>[] => {
  const { t } = useCustomTranslation()

  return [
    {
      label: t('smartHome.actuators.options.switch'),
      value: 16,
    },
    {
      label: t('smartHome.actuators.options.dimmer'),
      value: 17,
    },
    {
      label: t('smartHome.actuators.options.blinds'),
      value: 27,
    },
    {
      label: t('smartHome.actuators.options.timer'),
      value: 70,
    },
    {
      label: t('smartHome.actuators.options.solar'),
      value: 72,
    },
    {
      label: t('smartHome.actuators.options.battery'),
      value: 71,
    },
    {
      label: t('smartHome.actuators.options.analog'),
      value: 73,
    },
    {
      label: t('smartHome.actuators.options.analogInverse'),
      value: 12,
    },
    {
      label: t('smartHome.actuators.options.powermeter'),
      value: 76,
    },
    {
      label: t('smartHome.actuators.options.feedIn'),
      value: 77,
    },
    {
      label: t('smartHome.actuators.options.emergency'),
      value: 78,
    },
  ]
}

export const useActuatorIndices = (actors: Actuator[]): LabeledOption<number>[] => {
  const initialArray = Array.from(Array(100).keys())
  const usedIndeces = actors.map(actor => actor.index)
  const filteredIndices = initialArray.filter(index => index > 0 && !usedIndeces.includes(index))

  return filteredIndices.map(idx => ({
    label: idx.toString(),
    value: idx,
  }))
}
